<ng-template #feedbackItem let-comment>
    <div class="panel panel-default">
        <div class="panel-body">
            @if (comment.reviewer === 'AI' && comment.status === 'failed') {
                <div class="feedback-subtext">
                    <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
                    <span>{{ 'interviews.AI Feedback failed on {date}' | translate: {date: (comment.modified | date:'MMM d, y, h:mm a')} }}</span>
                </div>
                <div>{{ 'interviews.AI Feedback Failed Content' | translate }}</div>
            } @else if (comment.reviewer === 'AI' && ['pending', 'queued', 'started'].includes(comment.status)) {
                <div class="feedback-subtext">
                    <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
                    <span>{{ 'interviews.AI Feedback processing on {date}' | translate: {date: (comment.created | date:'MMM d, y, h:mm a')} }}</span>
                </div>
                <div>{{ 'interviews.AI Feedback Processing Content' | translate }}</div>
            } @else if (comment.reviewer === 'AI') {
                <app-rating class="read-only clearfix" [rating]="comment.rating" [itemId]='3'></app-rating>
                <div class="feedback-subtext">
                    <strong>{{ 'interviews.AI Feedback' | translate }} </strong>
                    <span>{{ 'interviews.generated on {date}' | translate: {date: (comment.modified | date:'MMM d, y, h:mm a')} }}</span>
                </div>
                <div class="feedback-review" [innerHTML]="comment.review | keepHtml"></div>
            } @else {
                <app-rating class="read-only clearfix" [rating]="comment.rating" [itemId]='3'></app-rating>
                <div class="feedback-subtext">
                    <span>{{ 'interviews.Submitted by' | translate }} </span>
                    <strong>{{ comment.reviewer }}</strong>
                    <span> {{ 'interviews.on {date}' | translate: {date: (comment.modified | date:'MMM d, y, h:mm a')} }}</span>
                </div>
                <div class="feedback-review">{{ comment.review }}</div>
            }
        </div>
    </div>
</ng-template>

<ng-container *ngIf="data.length; else singleItem">
    <ng-container *ngFor="let comment of data">
        <ng-container *ngTemplateOutlet="feedbackItem; context: { $implicit: comment }"></ng-container>
    </ng-container>
</ng-container>

<ng-template #singleItem>
    <ng-container *ngTemplateOutlet="feedbackItem; context: { $implicit: data }"></ng-container>
</ng-template>
